import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    buttonContainers: {
        width: 'max-content',
        display: 'inline-flex',
    },
    buttonItem: {
        display: 'inline-block',
    },
    spaced: {
        marginRight: theme.spacing(1),
    },
}))

export interface EditModeButtonsProps {
    onCancel?: () => void
    onSave?: () => void
    onSaveAndExit?: () => void
    cancelButtonLoading?: boolean
    saveButtonLoading?: boolean
    saveAndExitButtonLoading?: boolean
    disabled?: boolean
    editModeButtonsContainerRef?: React.RefObject<HTMLDivElement>
}

const EditModeButtons: React.FC<EditModeButtonsProps> = ({
    onCancel,
    onSave,
    onSaveAndExit,
    cancelButtonLoading,
    saveButtonLoading,
    saveAndExitButtonLoading,
    disabled = false,
    editModeButtonsContainerRef,
}) => {
    const classes = useStyles()
    return (
        <div
            ref={editModeButtonsContainerRef}
            className={classes.buttonContainers}
            onKeyDown={(e) => {
                if (e.key === 'Escape') {
                    onCancel?.()
                }
            }}
        >
            <div className={clsx(classes.buttonItem, classes.spaced)}>
                <RoundButton
                    borderColor="#ffffff"
                    backgroundColor="#0069AA"
                    onClick={onCancel}
                    loading={cancelButtonLoading}
                    hasShadow={false}
                >
                    Cancel
                </RoundButton>
            </div>
            <div className={clsx(classes.buttonItem, classes.spaced)}>
                <RoundButton
                    hasShadow={false}
                    borderColor="#04325B"
                    onClick={onSave}
                    loading={saveButtonLoading}
                    backgroundColor="#ffffff"
                    color="#0098D6"
                    disabled={disabled}
                >
                    Save
                </RoundButton>
            </div>
            <div className={clsx(classes.buttonItem)}>
                <RoundButton
                    hasShadow={false}
                    borderColor="#04325B"
                    backgroundColor="#ffffff"
                    color="#0098D6"
                    loading={saveAndExitButtonLoading}
                    disabled={disabled}
                    onClick={onSaveAndExit}
                >
                    Save and Exit
                </RoundButton>
            </div>
        </div>
    )
}

export default EditModeButtons
